/**
 * Cart icon with item count bubble
 * Manages the shopping cart icon in the header with item count display
 * Handles cart drawer toggle functionality when clicked
 */

if (!customElements.get('cart-icon-bubble')) {
  class CartIconBubble extends HTMLElement {
  constructor() {
    super();

    this.toggleButton = this.querySelector('button');
    this.cartDrawer = document.querySelector('cart-drawer');

    if (this.cartDrawer) {
      this.toggleButton.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    this.cartDrawer.drawer.classList.contains(this.cartDrawer.activeClass)
    ? this.cartDrawer.close() 
    : this.cartDrawer.open();
  }
}


  customElements.define('cart-icon-bubble', CartIconBubble);
}
